function setPeriods(data) {
	return {
		type: 'SET_PERIODS',
		payload: data,
	};
}

export { setPeriods };
